<template>
  <the-dialog-box
    ref="dialogBox"
    :submit="submit"
    :submit-btn-text="'Reject'"
    :max-width="800"
  >
    <template slot="header">
      <span>Reject Request# {{ itemId }}</span>
    </template>
    <template slot="body">
      <VueEditor
        v-model="note"
        placeholder="Enter reject note"
        :editor-toolbar="customToolbar"
      />
    </template>
  </the-dialog-box>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { VueEditor } from 'vue2-editor';

export default {
  components: {
    VueEditor,
  },
  props: {

  },
  data: () => ({
    itemId: null,
    note: '',
    customToolbar: [
      ['bold', 'italic', 'underline'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [
        { align: '' },
        { align: 'center' },
        { align: 'right' },
        { align: 'justify' },
      ],
      [{ color: [] }],
    ],
  }),
  computed: {
    ...mapState({
      user: 'user',
    }),
    ...mapGetters([

    ]),
  },
  watch: {

  },
  created() {
    this.item = { ...this.itemDto };
  },
  methods: {

    async submit() {
      if (!this.item) return false;
      const statusIdRejected = 6;
      const submitData = {
        id: this.itemId,
        status_id: statusIdRejected,
        note: this.note,
        user_id: this.user.id,
      };
      const res = await this.$api.stmsRequest.store(submitData, 'reject');

      if (!res) {
        this.$bus.$emit('showError');
        return false;
      }

      this.$bus.$emit('showSuccess');
      this.$emit('success');
      return res;
    },

    open(item) {
      if (!item) return;
      this.itemId = item.id;
      this.note = '';
      this.$refs.dialogBox.open();
    },
  },
};
</script>
